import { color } from "@smartsheet/design-tokens-react";
import { ttNormsProBoldFontFamily } from "../../../fonts/fonts";

/**
 * Font Sizing
 * (includes line height)
 */
export const fontSizeDefinitions = {
    "13": { fontSize: "13px", lineHeight: "18px" },
    "14": { fontSize: "14px", lineHeight: "18px" },
    "15": { fontSize: "15px", lineHeight: "18px" },
    "18": { fontSize: "18px", lineHeight: "24px" },
    "24": { fontSize: "24px", lineHeight: "28px" },
    "32": { fontSize: "32px", lineHeight: "34px" },
    "40": { fontSize: "40px", lineHeight: "48px" },
} as const;

/**
 * Font weight
 */
export const fontWeight = {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    normal: 400,
    medium: 500,
    semiBold: 600,
    demiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
    extraBlack: 950,
} as const;

/**
 * Font Family
 */
export const fontFamily = {
    ttNorms: ttNormsProBoldFontFamily,
    inter: '"Inter", Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";',
    interVar: '"Inter var", Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";',
} as const;

/**
 * Type ramp style definitions.
 * @deprecated Please use the TypeRampV2 components.
 */
export const typeRampDefinitions = {
    headlineXLarge: {
        fontWeight: fontWeight.bold,
        ...fontSizeDefinitions["40"],
        component: "span",
        theme: {
            light: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral--strong"),
            },
            dark: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral-inverse--strong"),
            },
            oldestar: { color: color("color--text--neutral--strong") },
        },
    },
    headlineLarge: {
        fontWeight: fontWeight.bold,
        component: "span",
        ...fontSizeDefinitions["32"],
        theme: {
            light: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral--strong"),
            },
            dark: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral-inverse--strong"),
            },
            oldestar: { color: color("color--text--neutral--strong") },
        },
    },
    headlineMedium: {
        fontWeight: fontWeight.bold,
        component: "span",
        ...fontSizeDefinitions["24"],
        theme: {
            light: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral--strong"),
            },
            dark: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral-inverse--strong"),
            },
            oldestar: { color: color("color--text--neutral--strong") },
        },
    },
    headlineSmall: {
        fontWeight: fontWeight.bold,
        component: "span",
        ...fontSizeDefinitions["18"],
        theme: {
            light: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral--strong"),
            },
            dark: {
                fontFamily: ttNormsProBoldFontFamily,
                color: color("color--text--neutral-inverse--strong"),
            },
            oldestar: { color: color("color--text--neutral--strong") },
        },
    },
    headerLarge: {
        fontWeight: fontWeight.semiBold,
        component: "span",
        ...fontSizeDefinitions["15"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    headerSmall: {
        fontWeight: fontWeight.semiBold,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    buttonLarge: {
        fontWeight: fontWeight.bold,
        component: "span",
        ...fontSizeDefinitions["14"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    buttonMedium: {
        fontWeight: fontWeight.semiBold,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    titlesEmphasis: {
        fontWeight: fontWeight.semiBold,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    bodyStrong: {
        fontWeight: fontWeight.medium,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    bodyText: {
        fontWeight: fontWeight.regular,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--default") },
            dark: {},
            oldestar: { color: color("color--text--neutral--default") },
        },
    },
    metadata: {
        fontWeight: fontWeight.regular,
        component: "span",
        ...fontSizeDefinitions["13"],
        theme: {
            light: { color: color("color--text--neutral--weak") },
            dark: {},
            oldestar: { color: color("color--text--neutral--weak") },
        },
    },
} as const;
